<!-- @format -->

<template>
	<el-input v-model="value" type="textarea"></el-input>
</template>

<script setup lang="ts">
	interface Props {
		modelValue: string | null; // 值
		options: any; // 属性
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: null,
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style scoped></style>
